import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import choices from "choices.js/public/types/src/scripts/reducers/choices";
import Choices from "choices.js";
import {Choice} from "choices.js/src/scripts/interfaces/choice";
import {EventInput} from "@fullcalendar/common";

interface WireParentSelectProps {
    wireAction: string,
    subselectSelector: string
}

/**
 * Komponent do
 * https://github.com/Choices-js/Choices
 */
@Dce("WireParentSelect")
export default class WireParentSelect extends DceComponent<WireParentSelectProps> {

    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: WireParentSelectProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        this.elem.addEventListener('change', e => {

            let value = (this.elem as unknown as HTMLSelectElement).value;

            this.parentFragment.action(this.props.wireAction, {
                value: value,
                subselectSelector: this.props.subselectSelector
            });

        });

    }
}